/**
 * Pokémon TCG series → sets mapping (English), sourced from
 * https://www.pokellector.com/sets
 *
 * Shop-specific series are appended at the end.
 */

export const SERIES_SET_MAP = {
  'Mega Evolution': [
    '30th Celebration (English)',
    'Pitch Black',
    'Chaos Rising',
    'Perfect Order',
    'Ascended Heroes',
    'Phantasmal Flames',
    'Mega Evolution',
    'Mega Evolution Energies',
    'Mega Evolution Black Star Promos',
  ],
  'Scarlet & Violet': [
    'White Flare',
    'Black Bolt',
    'Destined Rivals',
    'Journey Together',
    "McDonald's Dragon Discovery",
    'Prismatic Evolutions',
    'Surging Sparks',
    'Stellar Crown',
    'Holiday Calendar 2024',
    'Trick or Trade 2024',
    'Shrouded Fable',
    'Twilight Masquerade',
    'Temporal Forces',
    'Paldean Fates',
    'Paradox Rift',
    'Scarlet & Violet - 151',
    '151',
    'Holiday Calendar 2023',
    'Trick or Trade 2023',
    "McDonald's Match Battle 2023",
    'Obsidian Flames',
    'Paldea Evolved',
    'Scarlet & Violet Energies',
    'Scarlet & Violet',
    'Scarlet & Violet Base',
    'Scarlet & Violet Promos',
  ],
  'Sword & Shield': [
    'Crown Zenith',
    'Crown Zenith - Galarian Gallery',
    'Silver Tempest',
    'Silver Tempest - Trainer Gallery',
    'Lost Origin',
    'Lost Origin - Trainer Gallery',
    'Holiday Calendar 2022',
    'Trick or Trade',
    "McDonald's Match Battle",
    'Pokemon Go',
    'Astral Radiance',
    'Astral Radiance - Trainer Gallery',
    'Brilliant Stars',
    'Brilliant Stars - Trainer Gallery',
    'Fusion Strike',
    'Celebrations',
    'Evolving Skies',
    'Chilling Reign',
    'Battle Styles',
    'Shining Fates',
    "McDonald's 25th Anniversary",
    'Vivid Voltage',
    "Champion's Path",
    'Pokemon Futsal Promos',
    'Darkness Ablaze',
    'Rebel Clash',
    'Sword & Shield',
    'Sword & Shield Promos',
  ],
  'Sun & Moon': [
    'Cosmic Eclipse',
    "McDonald's Collection (2019 FR)",
    "McDonald's Collection (2019)",
    'Hidden Fates',
    'Unified Minds',
    'Unbroken Bonds',
    'Detective Pikachu',
    'Team Up',
    'Lost Thunder',
    "McDonald's Collection (2018)",
    'Dragon Majesty',
    'Celestial Storm',
    'Forbidden Light',
    'Ultra Prism',
    'Crimson Invasion',
    'Shining Legends',
    'Burning Shadows',
    "McDonald's Collection (2017)",
    'Guardians Rising',
    'Sun & Moon Promos',
    'Sun & Moon',
  ],
  XY: [
    'Evolutions',
    "McDonald's Collection (2016)",
    'Steam Siege',
    'Fates Collide',
    'Generations',
    'BREAKPoint',
    "McDonald's Collection (2015)",
    'XY BREAKthrough',
    'Ancient Origins',
    'Roaring Skies',
    'Double Crisis',
    'Primal Clash',
    'Phantom Forces',
    'Furious Fists',
    "McDonald's Collection (2014)",
    'XY Flashfire',
    'Kalos Starter Set',
    'XY Promos',
    'XY',
  ],
  'Black & White': [
    'Radiant Collection',
    'Legendary Treasures',
    'Plasma Blast',
    'Plasma Freeze',
    'Plasma Storm',
    'Boundaries Crossed',
    'Dragon Vault',
    'Dragons Exalted',
    'Dark Explorers',
    'Next Destinies',
    'Noble Victories',
    'Emerging Powers',
    'Black & White',
  ],
  'Black & White Promos': [
    "McDonald's Collection (2013)",
    "McDonald's Collection (2012)",
    "McDonald's Collection (2011)",
    'Black & White Promos',
  ],
  'Call of Legends': ['Call of Legends'],
  'HeartGold SoulSilver': [
    'HS Triumphant',
    'HS Undaunted',
    'HS Unleashed',
    'HeartGold SoulSilver Promos',
    'HeartGold SoulSilver',
  ],
  Platinum: [
    'Pokemon Rumble',
    'Platinum - Arceus',
    'Platinum - Supreme Victors',
    'Platinum - Rising Rivals',
    'Platinum',
  ],
  'Nintendo Promos': [
    'POP Series 9',
    'POP Series 8',
    'POP Series 7',
    'POP Series 6',
    'POP Series 5',
    'POP Series 4',
    'POP Series 3',
    'POP Series 2',
    'POP Series 1',
    'Nintendo Promos',
  ],
  'Diamond & Pearl': [
    'Stormfront',
    'Legends Awakened',
    'Majestic Dawn',
    'Great Encounters',
    'Secret Wonders',
    'Mysterious Treasures',
    'DP Black Star Promos',
    'Diamond & Pearl',
  ],
  'EX Ruby & Sapphire': [
    'EX Power Keepers',
    'EX Dragon Frontiers',
    'EX Crystal Guardians',
    'EX Holon Phantoms',
    'EX Legend Maker',
    'EX Delta Species',
    'EX Unseen Forces Unown Collection',
    'EX Unseen Forces',
    'EX Emerald',
    'EX Deoxys',
    'EX Team Rocket Returns',
    'EX FireRed & LeafGreen',
    'EX Hidden Legends',
    'EX Team Magma vs Team Aqua',
    'EX Dragon',
    'EX Sandstorm',
    'EX Ruby & Sapphire',
  ],
  'e-Card': ['Skyridge', 'Aquapolis', 'Best of Game', 'Expedition'],
  'Legendary Collection': ['Legendary Collection'],
  'Neo Genesis': [
    'Neo Destiny',
    'Neo Revelation',
    'Southern Islands',
    'Neo Discovery',
    'Neo Genesis',
  ],
  'Topps Chrome': ['Topps Series 3', 'Topps Series 2', 'Topps Series 1'],
  'Gym Heroes': ['Gym Challenge', 'Gym Heroes'],
  'Base Set': [
    'Team Rocket',
    'Base Set 2',
    'Fossil',
    'Wizards of the Coast Promos',
    'Jungle',
    'Base Set',
  ],
  'One More Rip Exclusive': ['Mixed'],
  'Illustration Collection': ['First Partner s2', 'First Partner s1'],
  Protection: ['Accessories'],
} as const;

export type ProductSeries = keyof typeof SERIES_SET_MAP;

type SeriesSets = (typeof SERIES_SET_MAP)[ProductSeries];
export type ProductSet = SeriesSets[number];

export const PRODUCT_SERIES = Object.keys(SERIES_SET_MAP) as [ProductSeries, ...ProductSeries[]];

const allSets = [...new Set(Object.values(SERIES_SET_MAP).flat())];
export const PRODUCT_SETS = allSets as [ProductSet, ...ProductSet[]];

/** Sets available for a series (empty when series is unset). */
export function setsForSeries(series: ProductSeries | '' | undefined): readonly ProductSet[] {
  if (!series) return [];
  return SERIES_SET_MAP[series as ProductSeries] ?? [];
}

export function isSetInSeries(set: ProductSet, series: ProductSeries): boolean {
  return (SERIES_SET_MAP[series] as readonly string[]).includes(set);
}
